// extracted by mini-css-extract-plugin
module.exports = {"error-panel":"_1DbPJlr0Sv5OX1qAzt1Uin","error-panel__dismiss":"_105QE1un-aWcohYRkBt9hV"};